<template>
    <div :class="$style.accordion">
        <div
            tabindex="0"
            :class="{
                [$style.accordionHeader]: true,
                [$style.activeAccordionHeader]: isFilterExpanded,
            }"
            aria-haspopup="dialog"
            role="button"
            @keyup.space="toggleFilterExpansion()"
            @keyup.enter="toggleFilterExpansion()"
            @click="toggleFilterExpansion()"
        >
            <div :class="$style.accordionLabel">{{ filter.label }} {{ formatFilterCount() }}</div>
            <div :class="$style.accordionIcon">
                <FontAwesomeIcon :icon="accordionIcon" />
            </div>
        </div>
        <div v-if="isFilterExpanded" :class="$style.accordionContent">
            <fieldset :class="$style.multiSelectDropdown" >
                <ul style="width: 100%">
                    <li
                        v-for="option in filter.options"
                        :key="option.id"
                        :class="{
                            [$style.multiSelectRow]: true,
                            [$style.checked]: option.isChecked,
                            [$style.subChoice]: option.type === 'adminArea',
                        }"
                    >
                        <label :for="option.id.toString()">
                            <input
                                :id="option.id.toString()"
                                :class="$style.inputAccent"
                                type="checkbox"
                                :checked="option.isChecked"
                                :value="option.isChecked"
                                @input="optionClickedHandler(option.id)"        
                            />
                            {{ trimCityOf(option.name) }}
                        </label>
                    </li>
                </ul>
            </fieldset>
        </div>
    </div>
</template>

<script>
import { faChevronUp, faChevronDown } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
    name: 'JobFilter',
    components: {
        FontAwesomeIcon,
    },
    props: {
        filter: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            isFilterExpanded: this.filter.isInitiallyExpanded,
        }
    },
    computed: {
        chevronUp() {
            return faChevronUp
        },
        chevronDown() {
            return faChevronDown
        },
        accordionIcon() {
            return this.isFilterExpanded ? this.chevronUp : this.chevronDown
        },
    },
    methods: {
        toggleFilterExpansion() {
            this.isFilterExpanded = !this.isFilterExpanded
        },
        formatFilterCount() {
            return this.filter.options.filter(option => option.isChecked).length > 0
                ? `(${this.filter.options.filter(option => option.isChecked).length})`
                : ''
        },
        optionClickedHandler(optionId) {
            this.$emit('optionClicked', { type: this.filter.name, optionId })
        },
        trimCityOf(inputString) {
            return inputString.endsWith(", City of") ? inputString.slice(0, -9) : inputString
        }
    },
}
</script>

<style module src="./JobFilter.css" />
